import $ from 'jquery';
import 'jquery.marquee';

const defaultOptions = {
  duration: 30000,
  delayBeforeStart: 100,
  direction: 'right',
  // duplicated: true,
  startVisible: true,
  pauseOnHover: false,
};

const initMarquee = (element, direction = 'left', duration = 30000, delay = 100) => {
  $(element).marquee({
    ...defaultOptions,
    direction,
    duration,
    delay,
  });
};

export default initMarquee;
